module.exports = __webpack_public_path__ + "media/images/sport--Para_Eishockey-ec2e4fb7d29f659bc7fb6ea31312343d.png";